import type { FormHTMLAttributes, ReactNode } from "react";

type CredentialField = { label: string; control: ReactNode; hideLabel?: boolean };
type Props = Pick<FormHTMLAttributes<HTMLFormElement>, "action" | "method" | "onSubmit"> & {
  identity: CredentialField;
  credential: CredentialField;
  submit: ReactNode;
  hiddenFields?: ReactNode;
  disabled?: boolean;
};

// Every credential login uses the same two field rows and action row.
// Callers supply controls and behavior, never a competing layout container.
export function LoginCredentialsForm({ identity, credential, submit, hiddenFields, disabled, ...formProps }: Props) {
  return <form {...formProps}>
    {hiddenFields}
    <fieldset disabled={disabled} className="auth-phone-form disabled:opacity-50">
      {[identity, credential].map((field, index) => <label className="rg-field" key={index}>
        <span className={field.hideLabel ? "invisible" : undefined}>{field.label}</span>
        {field.control}
      </label>)}
      {submit}
    </fieldset>
  </form>;
}
